import { apiRequest } from "./client";

export const planBillingApi = {
  listServices() {
    return apiRequest("/plan-billing/services");
  },

  // Alias compatible con código anterior.
  listPlans() {
    return apiRequest("/plan-billing/services");
  },

  getProject(projectId) {
    return apiRequest(`/plan-billing/projects/${projectId}`);
  },

  checkout(projectId, payload) {
    return apiRequest(`/plan-billing/projects/${projectId}/checkout`, {
      method: "POST",
      body: payload,
    });
  },

  payWithCard(projectId, payload) {
    return apiRequest(`/plan-billing/projects/${projectId}/card-payment`, {
      method: "POST",
      body: payload,
    });
  },

  // Compatibilidad con pantallas anteriores: mantiene el alta recurrente.
  subscribe(projectId, payload) {
    return apiRequest(`/plan-billing/projects/${projectId}/subscribe`, {
      method: "POST",
      body: payload,
    });
  },

  updatePaymentMethod(projectId, payload = {}) {
    return apiRequest(`/plan-billing/projects/${projectId}/payment-method`, {
      method: "POST",
      body: payload,
    });
  },

  refresh(projectId, payload = {}) {
    return apiRequest(`/plan-billing/projects/${projectId}/refresh`, {
      method: "POST",
      body: payload,
    });
  },

  pause(projectId) {
    return apiRequest(`/plan-billing/projects/${projectId}/pause`, {
      method: "POST",
      body: {},
    });
  },

  resume(projectId) {
    return apiRequest(`/plan-billing/projects/${projectId}/resume`, {
      method: "POST",
      body: {},
    });
  },

  cancel(projectId) {
    return apiRequest(`/plan-billing/projects/${projectId}/cancel`, {
      method: "POST",
      body: {},
    });
  },

  adminOverview() {
    return apiRequest("/owner/billing/overview");
  },

  updateService(serviceCode, payload) {
    return apiRequest(`/owner/billing/services/${serviceCode}/price`, {
      method: "PATCH",
      body: payload,
    });
  },

  getOwnerProjectControl(projectId) {
    return apiRequest(`/owner/billing/projects/${projectId}/control`);
  },

  updateProjectPricing(projectId, payload) {
    return apiRequest(`/owner/billing/projects/${projectId}/pricing`, {
      method: "PATCH",
      body: payload,
    });
  },

  settleProject(projectId, payload) {
    return apiRequest(`/owner/billing/projects/${projectId}/settle`, {
      method: "POST",
      body: payload,
    });
  },

  updateProjectModules(projectId, payload) {
    return apiRequest(`/owner/billing/projects/${projectId}/modules`, {
      method: "PATCH",
      body: payload,
    });
  },
};
